import React, { useState, useEffect } from "react";
import { useObserver } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Drawer } from "antd";
import { useStores } from "@/store";
import { Header, Loading, ListItem, Icon, Button, Locate } from "@/components";
import firebaseTrack from "@/service/firebase";
import Detail from "./components/detail";
import Appeal from "./components/appeal";
import "./index.less";
import InfiniteScroll from "react-infinite-scroller";
import { getQuery } from "@/service/http";
import EmptyBooking from "@/images/empty_bookings.svg";

let titleCache = {};
let loading = false;

/**
 * 我的预定-列表
 *
 */
const Main = () => {
  const { t } = useTranslation();
  const { bookingsStore, memberStore } = useStores();
  const [visible, setVisible] = useState(false);
  const [appealVisible, setAppealVisible] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [booking, setBooking] = useState({});

  useEffect(() => {
    getBookings(1);
    firebaseTrack({ screen_name: "My bookings" });

    // 直接打开申诉弹窗
    const { reservationCode, reservationId, widget } = getQuery();
    if (reservationCode && reservationId && widget === "appeal") {
      bookingsStore
        .getBookingById(reservationCode, reservationId)
        .then((data) => {
          setBooking({
            id: data.id,
            date: moment(data.reservation_date).format("YYYY-MM-DD"),
          });
          setAppealVisible(true);
        });
    }
  }, []);

  /**获取预定列表 */
  async function getBookings(page) {
    try {
      if (loading) return;
      loading = true;
      let { data = [] } = await bookingsStore.getBookings({
        type: "all",
        page,
      });
      if (data.length < 10) {
        setHasMore(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      loading = false;
    }
  }

  function loadMore(page) {
    getBookings(page);
  }

  /**点击查看详情 */
  function onItemChange(item) {
    bookingsStore.currentBooking = item;
    setVisible(true);
  }
  return useObserver(() => {
    const { bookings } = bookingsStore;
    return (
      <div className="page-bookings">
        <Locate />
        <Header title={t("WEB.My bookings")} />
        <Drawer
          className="booking-drawer myDeal-drawer"
          placement="right"
          closable={false}
          destroyOnClose
          onClose={() => setVisible(false)}
          visible={visible}
        >
          <Header
            title={t("WEB.Booking details")}
            onClick={() => setVisible(false)}
          />
          <Detail />
        </Drawer>

        {/* 直接申诉 */}
        <Drawer
          className="booking-drawer"
          placement="right"
          closable={false}
          destroyOnClose
          onClose={() => setAppealVisible(false)}
          visible={appealVisible}
        >
          <Header
            title={t("WEB.Appeal")}
            onClick={() => setAppealVisible(false)}
          />
          <Appeal date={booking.date} id={booking.id} />
        </Drawer>

        <div className="booking-list">
          {!bookings.length?(
              <div className="booking-empty">
                <img src={EmptyBooking} alt=""/>
                <div className="txt">
                  <div>{t('BOOKING.PLACEHOLDER.TXT1')}</div>
                  <div>{t('BOOKING.PLACEHOLDER.TXT2')}</div>
                </div>
              </div>
          ):(
            <InfiniteScroll
              initialLoad={false}
              pageStart={1}
              loadMore={loadMore}
              hasMore={hasMore}
              useWindow={true}
            >
              {bookings.map((item, index) => {
                return (
                  <BookItem
                    {...item}
                    key={item.id + "_" + index}
                    onClick={() => onItemChange(item)}
                  />
                );
              })}
              <div className="load-more">
                {hasMore && <Loading red></Loading>}
              </div>
            </InfiniteScroll>
          )}
        </div>
      </div>
    );
  });
};

const BookItem = ({
  restaurant,
  reservation_date,
  reservation_time,
  reservation_seats,
  section_title,
  status_lng,
  status,
  onClick,
  can_review,
  review,
  point = {},
}) => {
  let { t } = useTranslation();
  const [showTitle, setShowTitle] = useState(false);
  let date = moment(reservation_date).format(
    localStorage.getItem("lang") === "en" ? "dddd,MMMM DD" : "dddd, M月D日"
  );
  let time = moment(reservation_time).format("hh:mm A");

  /**查看餐厅详情 */
  function onRestaurantClick() {
    window.open(restaurant.website_detail_url, "_blank");
  }
  if (titleCache[section_title]) {
  } else {
    titleCache[section_title] = true;
    setShowTitle(true);
  }
  return (
    <React.Fragment>
      {/* 只展示每组第一个标题 */}
      {showTitle && <h2>{section_title}</h2>}
      <div className="book-item hairline-surround">
        {restaurant&&(
            <div
                className="book-restaurant hairline-bottom"
                onClick={onRestaurantClick}
            >
              <div className="cover">
                <img src={restaurant.cover} alt="" />
              </div>
              <div className="name">{restaurant.name}</div>
              <i className="arrow icon icon-arrow-right"></i>
            </div>
        )}
        <div className="book-detail" onClick={onClick}>
          <ListItem
            title={<Icon text={date} icon="icon icon-time" />}
            value={time}
          ></ListItem>
          <ListItem
            title={<Icon text={reservation_seats} icon="icon icon-seat" />}
            value={
              point && point.debit ? (
                <Icon
                  text={t("WEB.pointNumber", { points: point.debit })}
                  icon="icon icon-vip-grey"
                />
              ) : null
            }
          ></ListItem>
        </div>
        <footer>
          <div className="status-button" status={status}>
            {status_lng}
          </div>
          <ActionButton
            can_review={can_review}
            review={review}
            onClick={onClick}
          />
        </footer>
      </div>
    </React.Fragment>
  );
};

/**操作按钮 */
const ActionButton = ({ review, can_review, onClick }) => {
  let { t } = useTranslation();
  // if (can_review) {
  //   return (
  //     <Button type="primary" onClick={onClick}>
  //       <i className="icon icon-review"></i>
  //       {t("WEB.Review")}
  //     </Button>
  //   );
  // }
  if (review) {
    return <Icon text={t("WEB.Reviewed")} icon="icon icon-reviewed" />;
  }
  return (
    <Button type="primary" onClick={onClick}>
      <i className="icon icon-booking-white"></i>
      {t("WEB.Details")}
    </Button>
  );
};

export default Main;
